import http from "services/http";
import { FilterType } from "types/params";

const PRE_ENDPOINT = "/api/method/freshdi.api.web.v3";

type GetAllRFQType = {
  publish_status?: number | null;
  offset?: number;
  limit?: number;
};

export const apiGetAllRFQ = (data: GetAllRFQType) =>
  http.post(`${PRE_ENDPOINT}.rfq.get_my_rfqs`, data);

export const apiGetAllRFQMarket = (data?: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.get_rfqs`, data);

export const apiGetRFQStatus = () =>
  http.get(`${PRE_ENDPOINT}.rfq.get_rfq_status`);

export const apiCreateRFQ = (data: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.create_rfq`, data);

export const apiCreateQuicklyRFQ = (data: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.create_rfq_via_google`, data);

export const apiUpdateRFQ = (data: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.update_rfq`, data);

export const apiCreateInquiryViaGoogle = (data: any) =>
  http.post(`${PRE_ENDPOINT}.inquiry.create_inquiry_via_google`, data);

export const apiCreateInquiry = (data: any) =>
  http.post(`${PRE_ENDPOINT}.inquiry.create_inquiry`, data);

export const apiGetMyRFQDetail = (id: string) =>
  http.post(`${PRE_ENDPOINT}.rfq.get_my_rfq_details`, { rfq_id: id });

export const apiGetRFQDetail = (body: any) =>
  http.get(`${PRE_ENDPOINT}.rfq.get_rfq_details`, {params: body});

export const apiGetInquiryTargetInfo = (data: any) =>
  http.post(`${PRE_ENDPOINT}.inquiry.get_inquiry_target_info`, data);

export const apiGenerateRfqDetail = (data: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.generate_details`, data);

export const apiGenerateProductName = (data: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.generate_product_name`, data);

export const apiFeaturedRFQs = (data: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.get_featured_rfqs`, data);

export const apiGetRecommendedRFQs = (data: FilterType) =>
  http.get(`${PRE_ENDPOINT}.supplier.get_recommended_rfqs`, { params: data });

export const apiGenerateQuotationDetails = (data: any) =>
  http.post(`${PRE_ENDPOINT}.rfq.generate_quotation_details`, data);
export const apiUpdateQuotationResponse = (data: any) => 
  http.post(`${PRE_ENDPOINT}.customer.update_quotation_response`, data);